import { Link } from "react-router-dom";
import Answer from "./Answer";

const CardForm = ({ data }) => {
  return (
    <div className="card form">
      <div>FORMULAIRE</div>
      <div>{data.name}</div>
      <div>
        {/* go to edit the form by id */}
        <Link to={{ pathname: `/form/${data._id}/edit`, state: data }}>
          Éditer
        </Link>
        {/* go to answer questions of form by id */}
        <Answer data={data} />
      </div>
    </div>
  );
};
export default CardForm;
